module.exports = __webpack_public_path__ + "images/movies/ph-movie-poster.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/movies/ph-movie-poster.jpg
// module id = 460
// module chunks = 5